import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { type ActionMethods, type UserSelfPageData } from '..';
import PageTitle from '../PageTitle';
import { ActionButton } from '../styled';
import EditProfileContent from './EditProfileContent';

const useEditProfilePageData = (actions: ActionMethods) => {
    const { t } = useTranslation('userSelf');
    const page: UserSelfPageData = {
        type: 'editProfile',
        title: (
            <PageTitle
                extra={
                    <ActionButton
                        key="submit"
                        form="editProfileForm"
                        htmlType="submit"
                        icon={<CheckOutlined />}
                        type="link"
                    />
                }
                title={t('userSelf:editMyProfile.title')}
            />
        ),
        body: <EditProfileContent />,
        onMenuItemClicked: actions.goToEditProfile,
        onCloseOrBackClicked: actions.goBackToViewProfile,
    };

    return page;
};

export default useEditProfilePageData;
